import React, { useState, useCallback, useEffect, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { openTextModalAction, closeModalAction } from '../../../../actions/modal';
import ModifyNotificationSettings from '../Components/ModifyNotificationSettings';
import GroupDetailsInfo from './GroupDetailsInfo';
import ButtonScogoClosedOutlined from '../../../../common/Buttons/ButtonScogoClosedOutlined';
import { deepEqual, validateStringValue } from '../../../../utils/common';
import MemberList from '../Components/MemberList';
import MaterialIconToolTip from '../../../../common/MaterialIconToolTip';
import OverflowTip from '../../../../common/OverflowTip';
import CoversationMedia from '../Media';
import GroupTeam from './GroupTeam';
import SearchBox from '../../../../common/SearchBox';
import { SearchedMessage } from '../Search/SearchedMessage';
import IconToolTip from '../../../../common/IconToolTip';
import { isMobileView } from '../../../../utils/utils';
import { removeMembersInChat, updateChatById } from '../../../../actions/chat';
import { useNavigate } from 'react-router-dom';

const exitGroupFormName = 'exitGroupFormName';


function GroupDetails({ setShowMedia, isSearching, setIsSearching, searchTerm, setSeachQuery, showSearchedMessages, onKeyDownSeach, setShowSearchedMessages, mainChatContanerRef }) {
    const openedConversationId = useSelector((state) => state.conversations.openedConversationId);
    const dispatch = useDispatch();
    const closeModal = () => dispatch(closeModalAction());
    const [isEditEnable, setIsEditEnable] = useState(false);
    const [intialFormState, setIntialFormState] = useState({});
    const [editGroupDeatilsForm, setEditGroupDeatilsForm] = useState(intialFormState);
    const chatDetails = useSelector((state) => state.chat.chatDetails);
    const newLoggedUserData = useSelector((state) => state.auth.newLoggedUserData);
    const navigate = useNavigate();

    const groupDetails = useMemo(() => {
        if (chatDetails[openedConversationId]) {
            return chatDetails[openedConversationId];
        }
        return {};
    }, [chatDetails, openedConversationId]);

    const isLoggedUserIsAdmin = false;
    const [groupDetailsInfo, setGroupDetailsInfo] = useState(groupDetails);

    const [stepCount, setStepCount] = useState(0);

    useEffect(() => {
        setGroupDetailsInfo(groupDetails);
        setIsEditEnable(false);
    }, [groupDetails]);

    useEffect(() => {
        let intitalForm = {
            name: validateStringValue(groupDetailsInfo?.title),
            desc: validateStringValue(groupDetailsInfo?.description),
            conversationImage: '',
            preImage: groupDetailsInfo?.icon
        };
        setIntialFormState(intitalForm);
        setEditGroupDeatilsForm(intitalForm);
    }, [groupDetailsInfo]);

    const onFormInputChange = useCallback((event) => {
        const { name, value } = event.target ? event.target : event;
        setEditGroupDeatilsForm((prevState) => {
            return { ...prevState, [name]: value };
        });
    }, []);

    const onSearchClick = () => {
        setIsSearching(true);
        setStepCount(stepCount + 1);
    };

    const handleExitGroupModal = () => {
        const exitGroup = () => {
            dispatch(removeMembersInChat({ id: openedConversationId, users: [newLoggedUserData.user.id], navigate }));
        };
        let heading = 'Exit Group';
        let text = 'Are you sure you want to continue?';
        let buttons = [
            { showLoading: true, textOrComponent: 'Yes', type: 'red', onClick: exitGroup },
            { textOrComponent: 'No', type: 'blue', onClick: closeModal },
        ];
        let closeOnBackdropClick = false;
        dispatch(openTextModalAction({ heading, text, buttons, closeOnBackdropClick, formName: exitGroupFormName }));
    };

    const onSaveDetails = () => {
        setIsEditEnable(false);
        const payload = {
            title: editGroupDeatilsForm.name,
            description: editGroupDeatilsForm.desc,
        };
        if (editGroupDeatilsForm.conversationImage) payload.icon = editGroupDeatilsForm.conversationImage;
        dispatch(updateChatById({
            id: openedConversationId, payload
        }));
    };

    const conversationTeams = useMemo(() => {
        let teams = [];
        if (Array.isArray(groupDetailsInfo?.teams)) {
            teams = groupDetailsInfo.teams.sort((a, b) => a.name.localeCompare(b.name));
        }
        return teams;
    }, [groupDetailsInfo?.teams]);

    const saveDetailsIcon = () => {
        let className = 'hover:text-scogoorange cursor-pointer material-icons text-scogoprimary text-font16';
        let onClick = onSaveDetails;
        let title = 'Save Details';
        if (deepEqual(intialFormState, editGroupDeatilsForm)) {
            className = 'material-icons cursor-not-allowed text-font16 text-scogoprimary';
            onClick = () => { };
            title = 'No change found';
        }
        return (
            <div className='flex gap-2'>
                <MaterialIconToolTip onClick={onClick} title={title} materialIconName='save_as' materialIconClass={className} />
                <MaterialIconToolTip
                    onClick={() => setIsEditEnable(false)}
                    title={'Cancel'}
                    materialIconName='close'
                    materialIconClass='hover:text-scogoorange cursor-pointer material-icons text-scogoclosed text-font16'
                />
            </div>
        );
    };

    const backToChatList = () => {
        if (isMobileView && mainChatContanerRef) {
            mainChatContanerRef.current.classList.add('mobileChatListView');
            mainChatContanerRef.current.classList.remove('mobileUserDetailView');
        }
    };

    const groupDetailsBody = (
        <>
            <GroupDetailsInfo
                isEditEnable={isEditEnable}
                editGroupDeatilsForm={editGroupDeatilsForm}
                setEditGroupDeatilsForm={setEditGroupDeatilsForm}
                onFormInputChange={onFormInputChange}
                groupDetailsInfo={groupDetailsInfo}
            />
            <ModifyNotificationSettings
                conversationId={openedConversationId}
                sendNotificationsFor={groupDetailsInfo?.notification_mode}
                mainDivClass='p-5 px-6 border-t-10'
            />
            <CoversationMedia mainDivClass='p-5 px-6 border-t-10 w-full' setShowMedia={setShowMedia} />
            {/* <GroupProjectList conversationId={openedConversationId} projects={groupDetailsInfo?.projects} /> */}
            <MemberList
                conversationId={openedConversationId}
                detailsInfo={groupDetailsInfo}
                isLoggedUserIsAdmin={isLoggedUserIsAdmin}
                chatCustomerId={groupDetailsInfo?.info?.customerId}
            />
            <GroupTeam
                conversationId={openedConversationId}
                teams={conversationTeams}
                isLoggedUserIsAdmin={isLoggedUserIsAdmin}
                org_id={groupDetails?.org_id}
            />

            <div className='p-5 border-t-10'>
                <ButtonScogoClosedOutlined
                    buttonClass='w-full transition-all duration-300 hover:bg-red-50'
                    textOrComponent={'Exit Group'}
                    onClick={handleExitGroupModal}
                />
            </div>
        </>
    );

    return (
        <>
            <div className='chatContainerHeader top-0 sticky flex w-full items-center z-50 bg-white shadow-sm'>
                {isMobileView && (
                    <button
                        onClick={backToChatList}
                        className='flex items-center p-2 text-scogoprimary hover:text-scogoorange transition-colors'
                    >
                        <span className='material-icons m-0 font-bold'>chevron_left</span>
                        <span className='text-sm font-medium'>Back</span>
                    </button>
                )}

                {!isSearching && (
                    <div className='flex w-full items-center px-4 py-3 gap-2'>
                        <OverflowTip
                            textClass='text-scogo15 text-font14 font-medium lg:ml-0 ml-5 uppercase w-[80%]'
                            someLongText={groupDetailsInfo?.title || 'Group Details'}
                        />

                        <div className='ml-auto flex gap-3 items-center'>
                            {!isEditEnable ? (
                                <>
                                    <MaterialIconToolTip
                                        onClick={() => setIsEditEnable(true)}
                                        title='Edit Details'
                                        materialIconName='edit'
                                        materialIconClass='text-scogoprimary hover:text-scogoorange cursor-pointer material-icons text-font18 transition-colors'
                                    />
                                    <MaterialIconToolTip
                                        onClick={onSearchClick}
                                        title='Search Chat'
                                        materialIconName='search'
                                        materialIconClass='text-scogoprimary hover:text-scogoorange cursor-pointer material-icons text-font18 transition-colors'
                                    />
                                </>
                            ) : (
                                saveDetailsIcon()
                            )}
                        </div>
                    </div>
                )}

                {isSearching && (
                    <div className='h-full flex items-center w-full justify-between px-4 py-2'>
                        <SearchBox
                            searchTerm={searchTerm}
                            onChange={(event) => setSeachQuery(event.target.value.trimStart())}
                            placeholder={'Search chat messages...'}
                            inputWidthOnFocus='w-full'
                            inputWidth='w-full'
                            showClosedIcon={false}
                            onKeyDown={onKeyDownSeach}
                        />
                        <IconToolTip
                            title="Cancel"
                            onClick={() => {
                                setSeachQuery('');
                                setIsSearching(false);
                                setShowSearchedMessages(false);
                                setStepCount(0);
                            }}
                        >
                            <span className='text-scogoprimary hover:text-scogoorange cursor-pointer material-icons text-font18 ml-2 transition-colors'>
                                cancel
                            </span>
                        </IconToolTip>
                    </div>
                )}
            </div>

            <div className='groupDetailsHeight overflow-y-auto overflow-x-hidden bg-gray-50'>
                <div className='bg-white rounded-md shadow-sm '>
                    {showSearchedMessages ? (
                        <SearchedMessage searchTerm={searchTerm} />
                    ) : (
                        groupDetailsBody
                    )}
                </div>
            </div>
        </>
    );
}

export default GroupDetails;
